import { StyleSheet } from 'react-native'
import { Colors, Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes'

const styles = StyleSheet.create({
  offerTitle: {
    fontSize: 18,
    marginBottom: 8,
    fontWeight: 'bold',
    overflow: 'hidden'
  },
  nameHolder: { flexGrow: 0, flexShrink: 1 },
  autoMargin: {
    marginLeft: 'auto'
  },
  bold: {
    fontWeight: 'bold'
  },
  detailList: { paddingTop: 24, paddingLeft: 6 },
  offerIcon: {
    marginRight: 24
  },
  chevronIcon: {
    marginLeft: 12
  },
  price: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'baseline'
  },
  recap: {
    display: 'flex',
    paddingVertical: 24,
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 16
  },
  amount: {
    fontWeight: 'bold',
    fontSize: Fonts.size.regular
  },
  benefits: theme => ({
    backgroundColor: theme.colors.backgroundColorTwo
  }),
  detailEntry: {
    display: 'flex',
    paddingVertical: 16,
    flexDirection: 'row',
    paddingHorizontal: 24
  },
  moreBenefits: {
    paddingBottom: 32
  },
  benefit: {
    display: 'flex',
    paddingBottom: 16,
    flexDirection: 'row'
  },
  alignCenter: {
    alignItems: 'center'
  },
  text: {
    flexGrow: 1,
    fontSize: 16,
    flexShrink: 1,
    lineHeight: 18,
    textAlign: 'left'
  },
  detailsText: {
    paddingLeft: 8
  },
  icon: {
    marginRight: 24
  },
  buttonHolder: {
    borderTopWidth: 1,
    paddingVertical: 24,
    paddingHorizontal: 16,
    borderTopColor: Colors.activeGrey
  },
  includedText: theme => ({
    fontSize: 16,
    color: theme.colors.activeColor
  }),
  spaceBottom: {
    paddingBottom: 6
  }
})

export default styles
